import BaseListPresenter from "../../../base/BaseListPresenter";
import ExportCSVFunction from "../../../components/ExportCSVFunction";
import { findObjectUseCase } from "../../../usecases/object";
import {
  buildHierarchyWhere,
  findCurrentUserEmployee,
  getLastNonEmptyField,
} from "../../../utils/hierarchy";

class ScheduleReportPagePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase,
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }
  init() {
    this.limit = 50;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = ["Firstname", "Middlename", "surname"]; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  scheduleOrg = [
    "regions",
    "offices",
    "divisions",
    "sections",
    "units",
    "plantilla",
  ];

  createQuery(employees) {
    const currentUser = this.view.getCurrentUser();
    const roles = currentUser?.roles;
    const isScheduler = roles.some((item) => item.id === "Scheduler");
    if (isScheduler && Array.isArray(employees)) {
      const employee = employees[0];
      const lastNoneEmptyValue = getLastNonEmptyField(employee);
      this.view.setState({
        applyFilter: {
          [this.scheduleOrg[lastNoneEmptyValue.index]]:
            lastNoneEmptyValue.result,
        },
      });
      this.where = buildHierarchyWhere(employee);
    } else {
      this.where = { ...this.where };
    }
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const employees = await findCurrentUserEmployee(
      findObjectUseCase(),
      this.view.getCurrentUser(),
    );
    const query = this.createQuery(employees);
    // delete query.where.id;
    console.log("QUERT: ", query);
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      const applyFilter = this.view.state.applyFilter || {};
      console.log("applyFilter: ", applyFilter);
      const scheduleTemplate = await this.findObjectUseCase.execute(
        "schedule_template",
        { where: { ...applyFilter }, keys: ["name"] },
      );
      console.log("scheduleTemplate: ", scheduleTemplate);
      this.view.setState({ scheduleTemplate });
      // if (Object.keys(this.view.state.selectedSchedule).length > 0) {
      // }
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  async handleHierarchyChange(hierarchy) {
    const currentFilters = { ...this.view.state.filters };

    const formatter = {
      region: "regions",
      office: "offices",
      division: "divisions",
      unit: "units",
      cluster: "plantilla",
    };

    const hierarchyOrder = ["region", "office", "division", "unit", "cluster"];

    Object.entries(hierarchy).forEach(([key, value]) => {
      const mappedKey = formatter[key] ?? key;
      if (value) {
        currentFilters[mappedKey] = value;
      } else {
        delete currentFilters[mappedKey];
      }
    });

    // Get the last selected key in hierarchy order
    const lastSelectedKey = hierarchyOrder
      .filter((key) => hierarchy[key])
      .pop();

    // Build filter using only the last selected
    const applyFilter = lastSelectedKey
      ? { [formatter[lastSelectedKey]]: hierarchy[lastSelectedKey] }
      : {};

    this.view.setState({ applyFilter });

    this.view.setState(
      (prevState) => {
        const updatedFilters = { ...prevState.filters };

        // Explicitly remove keys that are now empty/null
        Object.entries(hierarchy).forEach(([key, value]) => {
          if (!value) {
            delete updatedFilters[key]; // Remove cleared keys
          } else {
            updatedFilters[key] = value; // Add/update active keys
          }
        });

        return { filters: updatedFilters };
      },
      () => {
        this.view.filterSubmit(this.view.state.filters);
      },
    );
  }

  async exportToCSV(fileName, schema) {
    const exportName = fileName.name;
    const query = this.createQuery();
    const fields = ["surname", "Firstname", "Middlename"];
    delete query.limit;

    const objects = await findObjectUseCase().execute(
      this.view.getCollectionName(),
      query,
    );
    ExportCSVFunction(objects, exportName, schema, fields);
  }
}
export default ScheduleReportPagePresenter;
